import { IResetPassword} from "../interfaces/authentication/reset-password.model.interface";

export class ResetPassword implements IResetPassword {
    public emailAddress: string;
    public token: string;
    public password: string;
    public confirmPassword: string;

  constructor(
        emailAddress: string,
        token: string,
        password: string = "",
        confirmPassword: string = ""
    ) {
        this.emailAddress = emailAddress;
        this.token = token;
        this.password = password;
        this.confirmPassword = confirmPassword;
    }
}
